export const BEGIN_BOOKING = 'INVITE_BEGIN_BOOKING'
export const CLEAR_SELECTION = 'INVITE_CLEAR_SELECTION'
export const COMPLETE_BOOKING = 'INVITE_COMPLETE_BOOKING'
export const CONFIRM_NEEDS = 'INVITE_CONFIRM_NEEDS'
export const SELECT_LOCATION = 'INVITE_SELECT_LOCATION'
export const SELECT_CLINICIAN_TYPE = 'INVITE_SELECT_CLINICIAN_TYPE'
export const SELECT_MEDIUM = 'INVITE_SELECT_MEDIUM'
export const SELECT_SLOT = 'INVITE_SELECT_SLOT'
export const UNDO_LAST_CONFIRMATION = 'INVITE_UNDO_LAST_CONFIRMATION'
